// extracted by mini-css-extract-plugin
export default {"img":"SerialsItem_img__YuRiQ","title":"SerialsItem_title__N8EeY"};